import React from 'react';
import { translate } from '../Services/translation';

const item = (name, value, decimalValue, bold = false) =>
  decimalValue !== 0 ? (
    <div className={'item' + (bold ? ' total-bold' : ' ')}>
      <span className="item-name">{name}</span>
      <span className="item-value">{value}</span>
    </div>
  ) : null;

const CheckoutOrderInfo = ({ cart, isBusinessCustomer, hideDelivery }) => (
  <div className="checkout__summary">
    {isBusinessCustomer
      ? item(
          translate('checkout.order.grandtotalbusiness'),
          cart.total,
          cart.decimalCardValues.total,
          true
        )
      : item(
          translate('checkout.order.grandTotal'),
          cart.grandTotal,
          cart.decimalCardValues.grandTotal,
          true
        )}
    {!isBusinessCustomer
      ? item(
          translate('checkout.order.totalnovat'),
          cart.total,
          cart.decimalCardValues.total
        )
      : null}
    {isBusinessCustomer
      ? null
      : item(
          translate('checkout.order.vat'),
          cart.vat,
          cart.decimalCardValues.vat
        )}
    {hideDelivery
      ? null
      : item(
          translate('checkout.order.deliverycost'),
          cart.deliveryCost,
          cart.decimalCardValues.deliveryCost
        )}
    {item(
      translate('checkout.order.paymentcost'),
      cart.paymentCost,
      cart.decimalCardValues.paymentCost
    )}
  </div>
);

export default CheckoutOrderInfo;
